import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "pb-24"
}
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { class: "px-3 appFont text-2xl text-center" }
const _hoisted_4 = { key: 1 }
const _hoisted_5 = { class: "text-center py-10" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_7 = { class: "appFont" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Post = _resolveComponent("Post")!
  const _component_Answer = _resolveComponent("Answer")!
  const _component_Spinner = _resolveComponent("Spinner")!
  const _component_Layout = _resolveComponent("Layout")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_Layout, {
      removePadding: true,
      "disable-top-nav": true
    }, {
      default: _withCtx(() => [
        (_ctx.data.question)
          ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
              (_ctx.data.question)
                ? (_openBlock(), _createBlock(_component_Post, {
                    key: 0,
                    post: _ctx.data.question,
                    "check-button": false
                  }, null, 8, ["post"]))
                : _createCommentVNode("", true),
              _createElementVNode("div", null, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.data.answers.data, (answer) => {
                  return (_openBlock(), _createBlock(_component_Answer, {
                    key: answer.id,
                    a: answer
                  }, null, 8, ["a"]))
                }), 128)),
                (_ctx.data.answers.data.length === 0)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                      _createElementVNode("h3", _hoisted_3, _toDisplayString(_ctx.$t('No answer found, be the first') + ' 😁'), 1)
                    ]))
                  : _createCommentVNode("", true)
              ])
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _createVNode(_component_Spinner, { class: "fa-2x" }),
                _hoisted_6,
                _createElementVNode("span", _hoisted_7, _toDisplayString(_ctx.$t('Just a moment')) + " ;)", 1)
              ])
            ]))
      ]),
      _: 1
    })
  ]))
}